export default function MaintenancePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-6 text-center" dir="rtl" style={{ background: "#FAF9F6" }}>
      <div className="w-24 h-24 flex items-center justify-center rounded-3xl bg-amber-100 border-2 border-gray-900">
        <i className="ri-tools-line text-5xl text-amber-500"></i>
      </div>
      <h1 className="text-3xl font-black text-gray-900">האתר בתחזוקה</h1>
      <p className="text-gray-500 max-w-md leading-relaxed">
        אנחנו עובדים כרגע על שיפור החוויה שלכם. נחזור בקרוב עם עוד תוכן מעולה!
      </p>
      <div className="flex items-center gap-3 px-6 py-3 bg-amber-50 border-2 border-amber-200 rounded-2xl">
        <div className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></div>
        <span className="text-sm font-bold text-amber-600">מצב תחזוקה</span>
      </div>
    </div>
  );
}
